
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Save } from 'lucide-react';

interface NewUser {
  name: string;
  email: string;
  accountNumber: string;
  licenseNumber: string;
}

interface AddUserFormProps {
  newUser: NewUser;
  onChange: (user: NewUser) => void;
  onSubmit: () => Promise<void>;
  onCancel: () => void;
  isSubmitting: boolean;
}

const AddUserForm: React.FC<AddUserFormProps> = ({
  newUser,
  onChange,
  onSubmit,
  onCancel,
  isSubmitting,
}) => {
  return (
    <div className="bg-muted/50 p-4 rounded-md mb-4">
      <h3 className="text-sm font-medium mb-3">Add New Authorized User</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <Input 
          placeholder="Name"
          value={newUser.name}
          onChange={(e) => onChange({ ...newUser, name: e.target.value })}
        />
        <Input 
          placeholder="Email"
          type="email"
          value={newUser.email}
          onChange={(e) => onChange({ ...newUser, email: e.target.value })}
        />
        <Input 
          placeholder="Account Number"
          value={newUser.accountNumber}
          onChange={(e) => onChange({ ...newUser, accountNumber: e.target.value })}
        />
        <Input 
          placeholder="Driver's License Number"
          value={newUser.licenseNumber}
          onChange={(e) => onChange({ ...newUser, licenseNumber: e.target.value })}
        />
      </div>
      <div className="flex justify-end space-x-2">
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={onSubmit} disabled={isSubmitting} variant="oval" size="oval">
          {isSubmitting ? (
            <>
              <div className="animate-spin mr-2 h-4 w-4 border-2 border-current border-t-transparent rounded-full" />
              Saving...
            </>
          ) : (
            <>
              <Save className="mr-2 h-4 w-4" />
              Save User
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default AddUserForm;
